import { ThemeVariant, getThemeVariant } from 'services/theming';

/* Lazy-load icons on demand: each is its own asset, fetched the first time a rule picks it. */
const iconLoaders = {
  './apple.svg': () => import('./apple.svg').then((m) => m.default),
  './artichoke.svg': () => import('./artichoke.svg').then((m) => m.default),
  './asparagus.svg': () => import('./asparagus.svg').then((m) => m.default),
  './avocado.svg': () => import('./avocado.svg').then((m) => m.default),
  './banana.svg': () => import('./banana.svg').then((m) => m.default),
  './Beans.svg': () => import('./Beans.svg').then((m) => m.default),
  './beetroot.svg': () => import('./beetroot.svg').then((m) => m.default),
  './berries.svg': () => import('./berries.svg').then((m) => m.default),
  './blackberry.svg': () => import('./blackberry.svg').then((m) => m.default),
  './blueberry.svg': () => import('./blueberry.svg').then((m) => m.default),
  './bringle.svg': () => import('./bringle.svg').then((m) => m.default),
  './broccoli.svg': () => import('./broccoli.svg').then((m) => m.default),
  './brussel-sprout.svg': () => import('./brussel-sprout.svg').then((m) => m.default),
  './butternut.svg': () => import('./butternut.svg').then((m) => m.default),
  './cabbage.svg': () => import('./cabbage.svg').then((m) => m.default),
  './carrot.svg': () => import('./carrot.svg').then((m) => m.default),
  './cart.svg': () => import('./cart.svg').then((m) => m.default),
  './cauliflower.svg': () => import('./cauliflower.svg').then((m) => m.default),
  './celery.svg': () => import('./celery.svg').then((m) => m.default),
  './cherry.svg': () => import('./cherry.svg').then((m) => m.default),
  './chilli.svg': () => import('./chilli.svg').then((m) => m.default),
  './coconut.svg': () => import('./coconut.svg').then((m) => m.default),
  './corn.svg': () => import('./corn.svg').then((m) => m.default),
  './cow.svg': () => import('./cow.svg').then((m) => m.default),
  './cucumber.svg': () => import('./cucumber.svg').then((m) => m.default),
  './dates.svg': () => import('./dates.svg').then((m) => m.default),
  './dragonfruit.svg': () => import('./dragonfruit.svg').then((m) => m.default),
  './equipment.svg': () => import('./equipment.svg').then((m) => m.default),
  './expert-advice.svg': () => import('./expert-advice.svg').then((m) => m.default),
  './Fennel.svg': () => import('./Fennel.svg').then((m) => m.default),
  './fertiliser.svg': () => import('./fertiliser.svg').then((m) => m.default),
  './fertilizer.svg': () => import('./fertilizer.svg').then((m) => m.default),
  './fig.svg': () => import('./fig.svg').then((m) => m.default),
  './fire.svg': () => import('./fire.svg').then((m) => m.default),
  './flower.svg': () => import('./flower.svg').then((m) => m.default),
  './garlic.svg': () => import('./garlic.svg').then((m) => m.default),
  './general-goods.svg': () => import('./general-goods.svg').then((m) => m.default),
  './ginger.svg': () => import('./ginger.svg').then((m) => m.default),
  './goggles.svg': () => import('./goggles.svg').then((m) => m.default),
  './gooseberry.svg': () => import('./gooseberry.svg').then((m) => m.default),
  './grapes.svg': () => import('./grapes.svg').then((m) => m.default),
  './greenbean.svg': () => import('./greenbean.svg').then((m) => m.default),
  './greenhouse.svg': () => import('./greenhouse.svg').then((m) => m.default),
  './guava.svg': () => import('./guava.svg').then((m) => m.default),
  './herb.svg': () => import('./herb.svg').then((m) => m.default),
  './irrigation-new.svg': () => import('./irrigation-new.svg').then((m) => m.default),
  './Kale.svg': () => import('./Kale.svg').then((m) => m.default),
  './kiwi.svg': () => import('./kiwi.svg').then((m) => m.default),
  './leek.svg': () => import('./leek.svg').then((m) => m.default),
  './lemon.svg': () => import('./lemon.svg').then((m) => m.default),
  './lime.svg': () => import('./lime.svg').then((m) => m.default),
  './litchi.svg': () => import('./litchi.svg').then((m) => m.default),
  './livestock.svg': () => import('./livestock.svg').then((m) => m.default),
  './mango.svg': () => import('./mango.svg').then((m) => m.default),
  './mushroom.svg': () => import('./mushroom.svg').then((m) => m.default),
  './muskmelon.svg': () => import('./muskmelon.svg').then((m) => m.default),
  './okra.svg': () => import('./okra.svg').then((m) => m.default),
  './onion.svg': () => import('./onion.svg').then((m) => m.default),
  './onionAndPotato.svg': () => import('./onionAndPotato.svg').then((m) => m.default),
  './orange.svg': () => import('./orange.svg').then((m) => m.default),
  './package.svg': () => import('./package.svg').then((m) => m.default),
  './Pakchoi.svg': () => import('./Pakchoi.svg').then((m) => m.default),
  './papaya.svg': () => import('./papaya.svg').then((m) => m.default),
  './parsnip.svg': () => import('./parsnip.svg').then((m) => m.default),
  './passion_fruit.svg': () => import('./passion_fruit.svg').then((m) => m.default),
  './peach.svg': () => import('./peach.svg').then((m) => m.default),
  './pear.svg': () => import('./pear.svg').then((m) => m.default),
  './pepper.svg': () => import('./pepper.svg').then((m) => m.default),
  './persimmons.svg': () => import('./persimmons.svg').then((m) => m.default),
  './pillow-pack.svg': () => import('./pillow-pack.svg').then((m) => m.default),
  './pineapple.svg': () => import('./pineapple.svg').then((m) => m.default),
  './plant-nutrition.svg': () => import('./plant-nutrition.svg').then((m) => m.default),
  './plum.svg': () => import('./plum.svg').then((m) => m.default),
  './pomegranate.svg': () => import('./pomegranate.svg').then((m) => m.default),
  './potato.svg': () => import('./potato.svg').then((m) => m.default),
  './power-products.svg': () => import('./power-products.svg').then((m) => m.default),
  './ppe.svg': () => import('./ppe.svg').then((m) => m.default),
  './pumpkin.svg': () => import('./pumpkin.svg').then((m) => m.default),
  './radish.svg': () => import('./radish.svg').then((m) => m.default),
  './raspberry.svg': () => import('./raspberry.svg').then((m) => m.default),
  './seedling.svg': () => import('./seedling.svg').then((m) => m.default),
  './sheaf-of-rice.svg': () => import('./sheaf-of-rice.svg').then((m) => m.default),
  './shoe.svg': () => import('./shoe.svg').then((m) => m.default),
  './soil-analysis.svg': () => import('./soil-analysis.svg').then((m) => m.default),
  './soup.svg': () => import('./soup.svg').then((m) => m.default),
  './spinach.svg': () => import('./spinach.svg').then((m) => m.default),
  './spring-onion.svg': () => import('./spring-onion.svg').then((m) => m.default),
  './strawberry.svg': () => import('./strawberry.svg').then((m) => m.default),
  './tomato.svg': () => import('./tomato.svg').then((m) => m.default),
  './turmeric.svg': () => import('./turmeric.svg').then((m) => m.default),
  './turnip-icon.svg': () => import('./turnip-icon.svg').then((m) => m.default),
  './value-added.svg': () => import('./value-added.svg').then((m) => m.default),
  './watermelon.svg': () => import('./watermelon.svg').then((m) => m.default),
  './welder.svg': () => import('./welder.svg').then((m) => m.default),
} satisfies Record<string, () => Promise<string>>;

type IconPath = keyof typeof iconLoaders;

/* Cache loaded URLs to avoid re-fetching. */
const urlCache = new Map<string, string>();

type IconMatcher = string | ((sku: string) => boolean);
type IconRule = [IconMatcher, IconPath];

const match = (sku: string, rule: IconRule): boolean => {
  const [pattern] = rule;
  return typeof pattern === 'string' ? sku.includes(pattern) : pattern(sku);
};

/* First-match-wins lookup. Order is critical. */
const findIconPath = (sku: string, rules: readonly IconRule[]): IconPath | null => {
  for (const rule of rules) {
    if (match(sku, rule)) return rule[1];
  }
  return null;
};

const INPUTS_ICON_RULES: readonly IconRule[] = [
  ['animal', './cow.svg'],
  ['fertiliser', './fertiliser.svg'],
  ['equipment', './equipment.svg'],
  ['irrigation', './irrigation-new.svg'],
  ['ppe', './ppe.svg'],
  ['seed', './seedling.svg'],
  ['packaging', './package.svg'],
  ['general', './cart.svg'],
  ['soil', './soil-analysis.svg'],
  ['power products', './power-products.svg'],
  ['plant', './plant-nutrition.svg'],
  ['greenhouse', './general-goods.svg'],
  ['fertilisers', './fertilizer.svg'],
  ['fire', './fire.svg'],
  ['growth', './greenhouse.svg'],
  ['goggles', './goggles.svg'],
  ['expert', './expert-advice.svg'],
  ['weld', './welder.svg'],
  ['livestock', './livestock.svg'],
];

/* Shared so rules that would otherwise swallow a tomato SKU (e.g. "Tomatoes mini plum") can exclude it. */
const isTomato = (sku: string): boolean => sku.includes('tomato') || (sku.includes('tom') && !sku.includes('mantom'));

/* Herbs whose names contain another product's keyword (lemon grass, lime leaves,
   garlic chives, rosemary) or no keyword at all. Checked before the produce rules
   so the ingredient-looking part of the name cannot claim them. */
const HERB_NAMES = [
  'basil',
  'bay lea',
  'chive',
  'coriand',
  'curry lea',
  'dill',
  'lemon gra',
  'lemongra',
  'lime lea',
  'mint',
  'oregan',
  'parsl',
  'rocket',
  'rosemar',
  'thyme',
];
const isHerb = (sku: string): boolean =>
  HERB_NAMES.some((h) => sku.includes(h)) || (sku.includes('sage') && !sku.includes('saus'));

/* Salad onions are spring onions; matched before 'onio' can claim them. */
const isSpringOnion = (sku: string): boolean =>
  sku.includes('springon') || sku.includes('spring on') || sku.includes('salad on');

/* Grocery-section product types, by type SKU code and by type name where the two differ. The SKU
   does not carry the section, so new grocery types must be added here. Types also sold under Value
   Added (juices, soups, eggs, sugar beans, cooked beetroot) are left to their own rules. */
const GROCERY_TYPE_CODES = new Set([
  'amazi',
  'bakedbeans',
  'beetgrate',
  'biscuit',
  'bleach',
  'bread',
  'butter',
  'cakeflour',
  'cereal',
  'chakalaka',
  'chips',
  'coffee',
  'cookingoil',
  'cordials',
  'cornedmeat',
  'cornflakes',
  'creamer',
  'custard',
  'detergent',
  'dishwashingliquid',
  'flour',
  'instporr',
  'jam',
  'laundsoap',
  'mabele',
  'macaroni',
  'mageu',
  'maizemeal',
  'marshmallows',
  'mayonnaise',
  'milk',
  'milkdairyblend',
  'mixedveg',
  'noodles',
  'oats',
  'peanb',
  'pilchards',
  'popc',
  'porridge',
  'redspeckbean',
  'rice',
  'salt',
  'samp',
  'sampbeans',
  'sauces',
  'shoppingbag',
  'soap',
  'softdrink',
  'soyamince',
  'spaghetti',
  'spices',
  'splitpe',
  'spread',
  'stockc',
  'sugarbrown',
  'sugarwhite',
  'tea',
  'toiletpaper',
  'tomatosauce',
  'vinegar',
  'washingpowder',
  'water',
  'weetbix',
  'yogurt',
]);
const GROCERY_TYPE_NAMES = [
  'beetroot grated',
  'instant porridge',
  'laundry soap',
  'peanut butter',
  'popcorn',
  'red speckled beans',
  'samp & beans',
  'shopping bag',
  'split peas',
  'stock cubes',
];
const isGrocery = (sku: string): boolean =>
  GROCERY_TYPE_CODES.has(sku.split(/[- ]/)[0]) || GROCERY_TYPE_NAMES.some((n) => sku === n || sku.startsWith(`${n} `));

const FRESH_PRODUCE_ICON_RULES: readonly IconRule[] = [
  [isGrocery, './value-added.svg'],
  ['juice', './value-added.svg'],
  ['soup', './soup.svg'],
  [isHerb, './herb.svg'],
  [isSpringOnion, './spring-onion.svg'],
  [(s) => s.includes('slicdic') || (s.includes('slice') && s.includes('dice')), './pillow-pack.svg'],
  ['potatoes & onions', './onionAndPotato.svg'],
  ['arti', './artichoke.svg'],
  ['pine', './pineapple.svg'],
  [(s) => s.includes('apple') || (s.includes('appl') && !s.includes('pine')), './apple.svg'],
  ['goose', './gooseberry.svg'],
  [(s) => s.includes('dragfr') || s.includes('dragon'), './dragonfruit.svg'],
  ['raspberries', './raspberry.svg'],
  [(s) => s.includes('aspar') || s.includes('bunches'), './asparagus.svg'],
  ['avo', './avocado.svg'],
  [(s) => s.includes('mar') && !s.includes('tommar') && !s.includes('roses'), './cucumber.svg'],
  [
    (s) =>
      s.includes('bana') || (!['stone', 'other', 'grape', 'passion'].some((x) => s.includes(x)) && s.includes('fruit')),
    './banana.svg',
  ],
  ['beans', './Beans.svg'],
  ['beet', './beetroot.svg'],
  ['strawb', './strawberry.svg'],
  ['blueb', './blueberry.svg'],
  ['blackb', './blackberry.svg'],
  ['berr', './berries.svg'],
  ['brin', './bringle.svg'],
  ['broc', './broccoli.svg'],
  [(s) => s.includes('brussel') || s.includes('sprout'), './brussel-sprout.svg'],
  [
    (s) =>
      s.includes('butt') && !s.includes('button') && !s.includes('let') && !s.includes('pil') && !s.includes('mushr'),
    './butternut.svg',
  ],
  ['cabb', './cabbage.svg'],
  ['carr', './carrot.svg'],
  ['caul', './cauliflower.svg'],
  [(s) => s.includes('cherr') && !s.includes('tomat'), './cherry.svg'],
  [(s) => s.includes('chil') && !s.includes('garl'), './chilli.svg'],
  ['cit', './orange.svg'],
  ['coconut', './coconut.svg'],
  [
    (s) => s.includes('corn') || s.includes('sweetcor') || s.includes('greenm') || s.includes('green mealie'),
    './corn.svg',
  ],
  ['cucum', './cucumber.svg'],
  [(s) => s.includes('date') || s.includes('medjool'), './dates.svg'],
  ['fennel', './Fennel.svg'],
  ['fig', './fig.svg'],
  ['garl', './garlic.svg'],
  ['ging', './ginger.svg'],
  [(s) => s.includes('turm') || s.includes('tumer'), './turmeric.svg'],
  ['grapef', './orange.svg'],
  [(s) => s.includes('grape') && !s.includes('fruit'), './grapes.svg'],
  [(s) => s.includes('patty pan') || s.includes('pattypa'), './pumpkin.svg'],
  [
    (s) =>
      (!['kiwi', 'pepp', 'mango', 'greenm', 'green mealie'].some((x) => s.includes(x)) && s.includes('green')) ||
      s.includes('grbeans'),
    './greenbean.svg',
  ],
  ['guav', './guava.svg'],
  ['kiwi', './kiwi.svg'],
  ['kale', './Kale.svg'],
  [(s) => s.includes('lettuce') || (s.includes('veg') && s.includes('leaf')), './cabbage.svg'],
  ['leek', './leek.svg'],
  ['turn', './turnip-icon.svg'],
  ['lemon', './lemon.svg'],
  [(s) => s.includes('mango') || s.includes('apricot') || s.includes('mantom'), './mango.svg'],
  ['mush', './mushroom.svg'],
  [(s) => (s.includes('melon') && !s.includes('water')) || s.includes('musk'), './muskmelon.svg'],
  ['onio', './onion.svg'],
  [
    (s) =>
      (s.includes('oran') || s.includes('pome')) &&
      !s.includes('pomegr') &&
      !s.includes('pomegranate') &&
      !s.includes('potato'),
    './orange.svg',
  ],
  ['okra', './okra.svg'],
  ['pak', './Pakchoi.svg'],
  ['papa', './papaya.svg'],
  /* Anchored to the type's SKU code so parsley (HERB-PARSITA, CELPARS) and pea shoots stay herbs. */
  [(s) => s.startsWith('pars-') || s.includes('parsnip'), './parsnip.svg'],
  [(s) => s.startsWith('peas') && !s.includes('shoot'), './Beans.svg'],
  [(s) => s.includes('pear') && !s.includes('pot') && !s.includes('pomegranate') && !s.includes('pearl'), './pear.svg'],
  [(s) => s.includes('peach') || s.includes('necta') || s.includes('stone'), './peach.svg'],
  ['pepp', './pepper.svg'],
  ['persimmon', './persimmons.svg'],
  ['pillow', './pillow-pack.svg'],
  [(s) => (s.includes('plum') || s.includes('stone') || s.includes('prune')) && !isTomato(s), './plum.svg'],
  [
    (s) =>
      ['potato', 'pototh', 'potmon', 'potsif', 'sweetpot', 'pother', 'potsou', 'pottys', 'potpan', 'pot'].some((x) =>
        s.includes(x),
      ) && !s.includes('potji'),
    './potato.svg',
  ],
  [(s) => s.includes('pomegr') || (!s.includes('passion') && s.includes('fruit')), './pomegranate.svg'],
  [(s) => s.includes('pump') && !s.includes('let'), './pumpkin.svg'],
  ['radish', './radish.svg'],
  ['rice', './sheaf-of-rice.svg'],
  ['show', './shoe.svg'],
  ['spina', './spinach.svg'],
  [
    (s) => ['squash', 'hub', 'gemsq', 'babgem', 'pattypa'].some((x) => s.includes(x)) && !s.includes('let'),
    './pumpkin.svg',
  ],
  [isTomato, './tomato.svg'],
  ['waterm', './watermelon.svg'],
  ['litch', './litchi.svg'],
  [(s) => s.includes('celery') || s.includes('tabcel'), './celery.svg'],
  ['lime', './lime.svg'],
  [(s) => s.includes('flower') || s.includes('floral') || s.includes('rose') || s.includes('bouq'), './flower.svg'],
  ['herb', './herb.svg'],
  ['passion', './passion_fruit.svg'],
  [(s) => s.includes('veg') && s.includes('other'), './asparagus.svg'],
  [(s) => s.includes('veg') && s.includes('baby'), './carrot.svg'],
  ['veg', './pepper.svg'],
  [(s) => ['value', 'shots', 'tubs'].some((x) => s.includes(x)), './value-added.svg'],
];

/* Returns the icon path for the given SKU, or null if no match. */
export const getIconPath = (inputSku: string): IconPath | null => {
  const sku = inputSku.toLowerCase();
  const theme = getThemeVariant();

  if (theme === ThemeVariant.Inputs) {
    return findIconPath(sku, INPUTS_ICON_RULES);
  }

  if (theme === ThemeVariant.Nile || theme === ThemeVariant.FreshMark) {
    return findIconPath(sku, FRESH_PRODUCE_ICON_RULES);
  }

  return null;
};

/* Returns cached URL if already loaded. Use for synchronous render when icon was loaded before. */
export const getCachedIconUrl = (path: string): string | null => urlCache.get(path) ?? null;

/* Load icon by path. Caches result. Icons are loaded on-demand as separate chunks. */
export const loadIcon = async (path: IconPath): Promise<string | null> => {
  const cached = urlCache.get(path);
  if (cached) return cached;

  const url = await iconLoaders[path]();
  if (url) urlCache.set(path, url);
  return url ?? null;
};
